import { CSSObject } from '@emotion/react';

export const clearFloat: CSSObject = {
    ':after': {
        content: "''",
        visibility: 'hidden',
        display: 'block',
        clear: 'both',
        height: 0,
    },
};
